import Dropdown, {
  DropdownProps,
} from "@app/common/components/Dropdown/Dropdown";
import DropdownMenuItem from "@app/common/components/Dropdown/DropdownMenuItem";
import { getSelectedFromOptions } from "@app/common/components/Dropdown/utils";

const ROLE_OPTIONS = [
  {
    label: "Admin only",
    value: "admin",
  },
  {
    label: "Admin & Manager",
    value: "manager",
  },
];

interface WorkspaceEditRoleDropdownProps extends DropdownProps {
  selected: string;
}

const WorkspaceEditRoleDropdown = (props: WorkspaceEditRoleDropdownProps) => (
  <Dropdown
    {...props}
    selectedItem={getSelectedFromOptions(ROLE_OPTIONS, props.selected)}
    sx={{
      width: "180px",
      minWidth: "180px",
      "&.MuiFormHelperText-root": { mr: 0 },
    }}
  >
    {ROLE_OPTIONS.map((item) => {
      const isSelectedItem = item.value === `${props.selected}`;
      return (
        <DropdownMenuItem
          key={item.value}
          {...item}
          selected={isSelectedItem}
        />
      );
    })}
  </Dropdown>
);

export default WorkspaceEditRoleDropdown;
